// extracted by mini-css-extract-plugin
export default {"Scroll":"ScrollLTR_Scroll__9ZDlI","RTL":"ScrollLTR_RTL__+7WeU"};